// libraries
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import moment from 'moment';

// vuex
import { mapGetters } from 'vuex';

// font
import font from '../assets/fonts/PTSans';

export default {
  data() {
    return {
      canvasPictureImg: null,
      format: 'HH:mm DD.MM.YYYY',
    };
  },
  computed: {
    ...mapGetters([
      'threadName',
    ]),
  },
  methods: {
    printPictureDocument() {
      html2canvas(document.querySelector('#picture'), {
        allowTaint: true,
        logging: false,
        taintTest: false,
      }).then((canvas) => {
        try {
          this.canvasPictureImg = canvas.toDataURL('image/png');
          this.printPicture();
        } catch (error) {
          console.error('picture print error: ', error);
        }
      });
    },
    setPictureDateTime() {
      return moment().format(this.format);
    },
    printPicture() {
      const doc = new jsPDF();
      doc.addFileToVFS('PTSans.ttf', font.PTSans);
      doc.addFont('PTSans.ttf', 'PTSans', 'normal');
      doc.setFont('PTSans');
      doc.setFontSize(16);
      doc.text(15, 15, `Картина дня ${this.threadName} на ${this.setPictureDateTime()}`);
      doc.addImage(this.canvasPictureImg, 'JPEG', 10, 25, 190, 135);
      doc.save(`Картина дня ${this.threadName} на ${this.setPictureDateTime()}.pdf`);
    },
  },
};
